import { styled } from "@mui/material/styles";
import { trainwellColor } from "../theme/themePrimitives";

/** Title used for most of the freeboarding screens. */
export const FreeboardingGradientTitle = styled("h5")(({ theme }) => ({
  background: `linear-gradient(90deg, ${trainwellColor.secondary3}, ${trainwellColor.primary3})`,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  ...theme.typography.h5,
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(2),
  textAlign: "center",
}));
